var React = require('react');

function WavyShape (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1152 1647L0 1647L0.000143394 6.76467C582.304 93.6047 667.675 -29.1109 1152 6.76477L1152 1647Z","fill":"#f8f9fa"}));
}

WavyShape.defaultProps = {"className":"wavy-background","width":"1152","height":"1647","viewBox":"0 0 1152 1647","preserveAspectRatio":"none"};

module.exports = WavyShape;

WavyShape.default = WavyShape;
